import enUS from './enUS.json'
import thTH from './thTH.json'

const locales = {
  enUS,
  thTH,
}

export default locales
